// extracted by mini-css-extract-plugin
export default {"support_link_wrapper":"SupportLink_support_link_wrapper__O9+Te","support_link":"SupportLink_support_link__Mw+w0"};